'use client';

import { ALPHABETHICAL, NEWEST } from '@/constants';
import { useSearch } from '@/app/search-context';
import Dropdown from './dropdown';

const options = [
  { value: ALPHABETHICAL, label: ALPHABETHICAL, },
  { value: NEWEST, label: NEWEST, },
];

export default function SortModelsClient({ className, }: { className: string }) {
  const { modelSort, setModelSort, dataLoading, } = useSearch();

  return (
    <Dropdown
      className={className}
      options={options}
      value={modelSort || ALPHABETHICAL}
      disabled={dataLoading}
      onChange={setModelSort}
    />
  );
}
